<template>
  <v-slide-x-transition>
    <v-list-tile v-if="feature" class="brands-selector-tile">
      <v-autocomplete
        v-model="model"
        chips
        clearable
        deletable-chips
        dense
        hide-details
        :items="brands"
        label="Marcas (opcional)"
        :loading="loadingBrands"
        multiple
        open-on-clear
        prepend-icon="branding_watermark"
        small-chips
      />
    </v-list-tile>
  </v-slide-x-transition>
</template>

<script>
import { mapMutations, mapState } from "vuex";

export default {
  computed: {
    ...mapState("featureRules", [
      "brands",
      "feature",
      "loadingBrands",
      "selectedBrands"
    ]),
    model: {
      get() {
        return this.selectedBrands;
      },
      set(brands) {
        this.setSelectedBrands(brands);
      }
    }
  },
  methods: {
    ...mapMutations("featureRules", ["setSelectedBrands"])
  }
};
</script>

<style>
.brands-selector-tile > .v-list__tile {
  height: auto;
}
</style>